import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalChangeActiveProductProps extends ModalEditComponentProps { }

const ModalChangeActiveProduct: React.FC<ModalChangeActiveProductProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivateProduct {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalDeleteProduct {...{ setOpened, onSubmit, allRowData }} />
    }
}


interface ModalReactivateProductProps extends ModalEditComponentProps { }

const ModalReactivateProduct: React.FC<ModalReactivateProductProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/updateProduct',
        data: {
            id: allRowData?.id,
            active: true
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureReactiveThisProduct', '¿Seguro que quieres reactivar este producto?'),
            subtitle: t('onceReactivatedAbleInProductList', 'Una vez reactivado volverá a aparecer en el listado de productos'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}


interface ModalDeleteProductProps extends ModalEditComponentProps { }

const ModalDeleteProduct: React.FC<ModalDeleteProductProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/deleteProduct',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureUnableProduct', '¿Seguro que quieres desactivar este producto?'),
            subtitle: t('onceUnabledCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
            buttonAccept: t('unable', 'Desactivar')
        }} />
    )
}

export default ModalChangeActiveProduct